import Card from "components/card";

import React, { useState, useEffect } from 'react';
import fetchData from "Hooks/useAPI";
import useAuth from "Hooks/useAuth";
import InputField from "components/fields/InputField";
import SelectField from "components/fields/SelectField";
import Spinner from "components/spinner";
import './style.css'

import { message } from 'antd';



function RegistrationForm() {
    const [rfc, setRfc] = useState('');
    const [razonSocial, setRazonSocial] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [regimenFiscal, setRegimenFiscal] = useState('601');
    const [usoCfdi, setUsoCfdi] = useState('G03');
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const btnClass = `${error ? 'shake' : ''} linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;
    const { logout } = useAuth()
    const [messageApi, contextHolder] = message.useMessage();
    const URL = 'https://adandyou.host/users_app/api/index.php/fiscal'

    useEffect(() => {
        setLoading(true)
        fetchData(URL, 'GET', null, {}, logout).then(function (response) {
            
            const  data  = response
           
            const { codigo_postal, razon, regimen_fiscal, rfc: rfcB, uso_cfdi } = data.data
            setRfc(rfcB)
            setRazonSocial(razon)
            setCodigoPostal(codigo_postal)
            setRegimenFiscal(regimen_fiscal)
            if (uso_cfdi !== "") {
                setUsoCfdi(uso_cfdi)
            }
            
        })
        .catch((ex)=>{
           
            setError("Error al guardar datos de facturación")
        })
        .finally(()=>{
            setLoading(false)
        })

    },[])

    const handleSubmit = async (event) => {
        event.preventDefault();
        let data = { rfc: rfc, razon: razonSocial, codigo_postal: codigoPostal, regimen_fiscal: regimenFiscal, uso_cfdi: usoCfdi }
        try {
            await fetchData(URL, 'POST', data, {}, logout)
            messageApi.open({
                type: 'success',
                content: "Guardado exitosamente",
              });
        } catch (error) {
            console.error(error);
            setError("Error al guardar datos de facturación")
            messageApi.open({
                type: 'error',
                content: "Error al guardar info intente de nuevo.",
              });
        }




    };

    return (
        <form className='billing-form' onSubmit={handleSubmit}>
            <InputField
                variant="admin"
                extra="mb-3"
                label="RFC"
                placeholder="..."
                id="rfc"
                type="text"
                onChange={e => setRfc(e.target.value)}
                value={rfc}
            />
            {/* <label htmlFor="rfc">RFC</label>
            <input type="text" id="rfc" value={rfc} onChange={(event) => setRfc(event.target.value)} /> */}

            {/* <label htmlFor="razonSocial">Razón social</label>
            <input type="text" id="razonSocial" value={razonSocial} onChange={(event) => setRazonSocial(event.target.value)} /> */}
            <InputField
                variant="admin"
                extra="mb-3"
                label="Razón social"
                placeholder="..."
                id="raz"
                type="text"
                onChange={e => setRazonSocial(e.target.value)}
                value={razonSocial}
            />

            {/* <label htmlFor="codigoPostal">Código postal</label>
            <input type="text" id="codigoPostal" value={codigoPostal} onChange={(event) => setCodigoPostal(event.target.value)} /> */}

            <InputField
                variant="admin"
                extra="mb-3"
                label="Código postal"
                placeholder="..."
                id="cp"
                type="text"
                onChange={e => setCodigoPostal(e.target.value)}
                value={codigoPostal}
            />

            {/* <label htmlFor="regimenFiscal">Régimen fiscal</label>
            <select id="regimenFiscal" value={regimenFiscal} onChange={(event) => setRegimenFiscal(event.target.value)}>
                <option value="601">601-General de Ley Personas Morales</option>
                <option value="603">603-Personas Morales con Fines no Lucrativos</option>
                <option value="606">606-Arrendamiento</option>
                <option value="607">607-Régimen de Enajenación o Adquisición de Bienes</option>
                <option value="608">608-Demás ingresos</option>
                <option value="609">609-Consolidación</option>
                <option value="610">610-Residentes en el Extranjero sin Establecimiento Permanente en México
                </option>
                <option value="611">611-Ingresos por Dividendos (socios y accionistas)</option>
                <option value="612">612-Personas Físicas con Actividades Empresariales y Profesionales</option>
                <option value="614">614-Ingresos por intereses</option>
                <option value="615">615-Régimen de los ingresos por obtención de premios</option>
                <option value="616">616-Sin obligaciones fiscales</option>
                <option value="620">620-Sociedades Cooperativas de Producción que optan por diferir sus ingresos
                </option>
                <option value="621">621-Incorporación Fiscal</option>
                <option value="622">Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                <option value="623">623-Opcional para Grupos de Sociedades</option>
                <option value="624">624-Coordinados</option>
                <option value="625">625-Régimen de las Actividades Empresariales con ingresos a través de
                    Plataformas Tecnológicas</option>
                <option value="626">626-Régimen Simplificado de Confianza</option>
                <option value="628">628-Hidrocarburos</option>
                <option value="629">629-De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales
                </option>
                <option value="630">630-Enajenación de acciones en bolsa de valores</option>

            </select> */}

            <SelectField
                variant="admin"
                extra="mb-3"
                label="Regimen Fiscal"
                id="fiscal-reg"
                onChange={e => setRegimenFiscal(e.target.value)}
                value={regimenFiscal}
            >
                <option value="">Elige regimen fiscal</option>
                <option value="601">601-General de Ley Personas Morales</option>
                <option value="603">603-Personas Morales con Fines no Lucrativos</option>
                <option value="606">606-Arrendamiento</option>
                <option value="607">607-Régimen de Enajenación o Adquisición de Bienes</option>
                <option value="608">608-Demás ingresos</option>
                <option value="609">609-Consolidación</option>
                <option value="610">610-Residentes en el Extranjero sin Establecimiento Permanente en México
                </option>
                <option value="611">611-Ingresos por Dividendos (socios y accionistas)</option>
                <option value="612">612-Personas Físicas con Actividades Empresariales y Profesionales</option>
                <option value="614">614-Ingresos por intereses</option>
                <option value="615">615-Régimen de los ingresos por obtención de premios</option>
                <option value="616">616-Sin obligaciones fiscales</option>
                <option value="620">620-Sociedades Cooperativas de Producción que optan por diferir sus ingresos
                </option>
                <option value="621">621-Incorporación Fiscal</option>
                <option value="622">Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                <option value="623">623-Opcional para Grupos de Sociedades</option>
                <option value="624">624-Coordinados</option>
                <option value="625">625-Régimen de las Actividades Empresariales con ingresos a través de
                    Plataformas Tecnológicas</option>
                <option value="626">626-Régimen Simplificado de Confianza</option>
                <option value="628">628-Hidrocarburos</option>
                <option value="629">629-De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales
                </option>
                <option value="630">630-Enajenación de acciones en bolsa de valores</option>
            </SelectField>
            {/* <label htmlFor="usoCfdi">Uso CFDI</label>
            <select id="usoCfdi" value={usoCfdi} onChange={(event) => setUsoCfdi(event.target.value)}>
                <option value="G03">G03-Gastos en general</option>
                <option value="G01">G01-Adquisición de mercancías</option>
                <option value="G02">G02-Devoluciones, descuentos o bonificaciones</option>
                <option value="G03">G03-Gastos en general</option>
                <option value="I01">I01-Construcciones</option>
                <option value="I02">I02-Mobiliario y equipo de oficina por inversiones</option>
                <option value="I03">I03-Equipo de transporte</option>
                <option value="S01">S01-Sin Efectos Fiscales</option>
            </select> */}

            <SelectField
                variant="admin"
                extra="mb-3"
                label="Uso CFDI"
                id="fiscal-re"
                onChange={e => setUsoCfdi(e.target.value)}
                value={usoCfdi}
            >
                <option value="">Elige uso cfdi</option>
                <option value="G03">G03-Gastos en general</option>
                <option value="G01">G01-Adquisición de mercancías</option>
                <option value="G02">G02-Devoluciones, descuentos o bonificaciones</option>
                <option value="G03">G03-Gastos en general</option>
                <option value="I01">I01-Construcciones</option>
                <option value="I02">I02-Mobiliario y equipo de oficina por inversiones</option>
                <option value="I03">I03-Equipo de transporte</option>
                <option value="S01">S01-Sin Efectos Fiscales</option>
            </SelectField>
            {contextHolder}
            <button disabled={loading} onClick={handleSubmit} className={btnClass}>
          {loading ? <Spinner/>: 'Guardar'}
        </button>
        </form>
    );
}


const InvoiceDataView = () => {
    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Datos de facturación
                </div>

            </header>
            <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
                <RegistrationForm />
            </div>
        </Card>
    )

}

export default InvoiceDataView